module.exports = __webpack_public_path__ + "static/media/bye1.7e9455fa.gif";